(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.closeBtn = this.querySelector('[data-drawer-close]');
      this.body = this.querySelector('[data-cart-body]');

      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      this.addEventListener('click', (e) => {
        const minus = e.target.closest('[data-qty-minus]');
        const plus = e.target.closest('[data-qty-plus]');
        const remove = e.target.closest('[data-remove-item]');

        if (minus) this.changeQuantity(minus, -1);
        if (plus) this.changeQuantity(plus, 1);
        if (remove) this.removeItem(remove);
      });

      document.addEventListener('cart:change', () => this.refresh());
    }

    open() {
      this.refresh();
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    async refresh() {
      const sectionId = this.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '') || 'cart-drawer';
      const response = await fetch(window.location.pathname + '?sections=' + sectionId);
      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newBody = temp.querySelector('[data-cart-body]');
      if (newBody && this.body) {
        this.body.innerHTML = newBody.innerHTML;
      }
    }

    async changeQuantity(btn, delta) {
      const item = btn.closest('[data-line-item]');
      if (!item) return;
      const key = item.getAttribute('data-key');
      const qtyEl = item.querySelector('[data-qty-value]');
      const currentQty = parseInt(qtyEl.textContent, 10);
      const newQty = Math.max(0, currentQty + delta);

      await this.updateCart(key, newQty);
    }

    async removeItem(btn) {
      const item = btn.closest('[data-line-item]');
      if (!item) return;
      const key = item.getAttribute('data-key');
      await this.updateCart(key, 0);
    }

    async updateCart(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      document.dispatchEvent(new CustomEvent('cart:updated'));
      await this.refresh();

      const badge = document.querySelector('cart-badge');
      if (badge) badge.update();
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        if (e.target.matches('.cart__quantity-input')) {
          this.onQuantityChange(e.target);
        }
      });

      this.addEventListener('click', (e) => {
        const removeLink = e.target.closest('[data-remove-item]');
        if (removeLink) {
          e.preventDefault();
          this.removeItem(removeLink);
        }
      });
    }

    async onQuantityChange(input) {
      const item = input.closest('[data-line-item]');
      if (!item) return;
      const key = item.getAttribute('data-key');
      const quantity = parseInt(input.value, 10);

      await this.updateCart(key, quantity);
    }

    async removeItem(btn) {
      const item = btn.closest('[data-line-item]');
      if (!item) return;
      const key = item.getAttribute('data-key');
      await this.updateCart(key, 0);
    }

    async updateCart(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      document.dispatchEvent(new CustomEvent('cart:change'));
      await this.refresh();
    }

    async refresh() {
      const sectionId = this.getAttribute('section-id');
      if (!sectionId) return;

      const response = await fetch(window.location.pathname + '?sections=' + sectionId);
      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newItems = temp.querySelector('cart-items');
      if (newItems) {
        this.innerHTML = newItems.innerHTML;
      }
    }
  }

  customElements.define('cart-items', CartItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-cta"] && !Shopify.designMode) return;
  try {
    
  // Opens an Omnisend popup/flyout form. The Omnisend snippet arrives via the
  // Shopify app embed, so it may not have loaded when this runs; pushing onto
  // the array stub is the documented way to queue the call until it does.
  class NewsletterCtaButton extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('[data-omnisend-form]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var formId = btn.getAttribute('data-omnisend-form');
        if (!formId) return;
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', formId]);
      });
    }
  }

  if (!customElements.get('newsletter-cta-button')) {
    customElements.define('newsletter-cta-button', NewsletterCtaButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-option-cards"] && !Shopify.designMode) return;
  try {
    
  class OrbitOptionCards extends HTMLElement {
    connectedCallback() {
      this.optionName = this.getAttribute('data-option-name') || '';
      this.optionOrder = (this.getAttribute('data-option-order') || '').split('|').filter(Boolean);
      this.myIndex = this.optionOrder.indexOf(this.optionName);
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.orbit-card'));

      var variantsEl = this.querySelector('[data-orbit-variants]');
      try {
        this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      var self = this;

      if (this.optionName) {
        this.cards.forEach(function(card) {
          card.addEventListener('click', function() {
            document.dispatchEvent(new CustomEvent('orbit:option-change', {
              detail: { name: self.optionName, value: card.getAttribute('data-orbit-value') }
            }));
          });
        });
      }

      this.boundSync = function(e) { self.syncFromState(e.detail); };
      document.addEventListener('orbit:variant-change', this.boundSync);

      // Request current state in case the hero connected first.
      document.dispatchEvent(new CustomEvent('orbit:request-state'));
    }

    disconnectedCallback() {
      if (this.boundSync) document.removeEventListener('orbit:variant-change', this.boundSync);
    }

    syncFromState(detail) {
      if (!detail || !detail.options || !this.optionName) return;
      var options = detail.options;
      var selectedValue = options[this.optionName];
      var self = this;

      this.cards.forEach(function(card) {
        var value = card.getAttribute('data-orbit-value');
        var isSelected = value === selectedValue;
        card.classList.toggle('orbit-card--selected', isSelected);
        if (card.hasAttribute('role')) {
          card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        }

        if (self.myIndex >= 0 && self.variants.length) {
          // Resolve the variant for this card's value combined with the
          // other currently-selected options, so price/availability reflect
          // the real Shopify variant.
          var variant = self.matchVariant(value, options);
          card.classList.toggle('orbit-card--unavailable', !(variant && variant.available));

          var priceEl = card.querySelector('[data-orbit-price]');
          if (priceEl && variant && variant.price_formatted) {
            priceEl.textContent = variant.price_formatted;
          }
        }
      });
    }

    matchVariant(value, options) {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        if (v.options[this.myIndex] !== value) continue;
        var ok = true;
        for (var k = 0; k < this.optionOrder.length; k++) {
          if (k === this.myIndex) continue;
          var nm = this.optionOrder[k];
          if (options[nm] != null && v.options[k] !== options[nm]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
  }

  customElements.define('orbit-option-cards', OrbitOptionCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class OrbitStickyCta extends HTMLElement {
    connectedCallback() {
      this.dismissed = false;
      var self = this;

      var dismissBtn = this.querySelector('[data-orbit-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function() {
          self.dismissed = true;
          self.hide();
        });
      }

      var heroSelector = this.getAttribute('data-hero-selector') || '.product-hero';
      var hero = document.querySelector(heroSelector);

      if (hero && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function(entries) {
          var entry = entries[0];
          if (self.dismissed) return;
          if (entry.isIntersecting) {
            self.hide();
          } else {
            self.show();
          }
        }, { threshold: 0 });
        this.observer.observe(hero);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    show() {
      this.hidden = false;
      this.classList.add('is-visible');
    }

    hide() {
      this.classList.remove('is-visible');
    }
  }

  customElements.define('orbit-sticky-cta', OrbitStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petelli-header"]) return;
  try {
    
  class MobileDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.closeBtn = this.querySelector('[data-drawer-close]');

      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trapFocus(e);
      });
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      const first = this.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      const trigger = document.querySelector('[aria-controls="' + this.id + '"]');
      if (trigger) trigger.focus();
    }

    trapFocus(e) {
      const focusable = this.querySelectorAll(
        'a[href], button:not([disabled]), details summary, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  class MegaMenuPreview extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('img');
      this.linksContainer = this.closest('.mega-menu__inner') && this.closest('.mega-menu__inner').querySelector('.mega-menu__links');
      if (!this.img || !this.linksContainer) return;

      this.defaultSrc = this.img.src;

      this.linksContainer.querySelectorAll('[data-preview-image]').forEach(link => {
        link.addEventListener('mouseenter', () => {
          const src = link.getAttribute('data-preview-image');
          if (src) this.swapImage(src);
        });
      });

      this.linksContainer.addEventListener('mouseleave', () => {
        this.swapImage(this.defaultSrc);
      });
    }

    swapImage(src) {
      this.img.style.opacity = '0';
      this.img.addEventListener('transitionend', () => {
        this.img.src = src;
        this.img.style.opacity = '1';
      }, { once: true });
    }
  }

  class CartBadge extends HTMLElement {
    connectedCallback() {
      document.addEventListener('cart:change', () => this.update());
      document.addEventListener('cart:updated', () => this.update());

      var link = this.querySelector('a');
      if (link) {
        link.addEventListener('click', function(e) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            e.preventDefault();
            drawer.open();
          }
        });
      }
    }

    async update() {
      var response = await fetch('/cart.js');
      var cart = await response.json();
      var count = cart.item_count;
      var span = this.querySelector('[data-cart-count]');
      if (span) {
        span.textContent = count;
        span.hidden = count === 0;
        span.classList.add('cart-badge--pulse');
        span.addEventListener('animationend', function() {
          span.classList.remove('cart-badge--pulse');
        }, { once: true });
      }
    }
  }

  var hamburger = document.querySelector('[aria-controls="mobile-drawer"]');
  var drawer = document.querySelector('#mobile-drawer');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', function() {
      var expanded = hamburger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        drawer.close();
        hamburger.setAttribute('aria-expanded', 'false');
      } else {
        drawer.open();
        hamburger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      drawer.close();
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      return;
    }
    var focused = document.activeElement;
    if (focused && focused.closest('.petelli-header__nav-item--has-dropdown')) {
      focused.blur();
    }
  });

  customElements.define('mobile-drawer', MobileDrawer);
  customElements.define('mega-menu-preview', MegaMenuPreview);
  customElements.define('cart-badge', CartBadge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('.product-hero__slide');
      this.thumbnails = this.querySelectorAll('.product-hero__thumbnail');
      this.prevBtn = this.querySelector('.product-hero__arrow--prev');
      this.nextBtn = this.querySelector('.product-hero__arrow--next');

      if (this.slides.length === 0) return;

      var zoomTriggers = this.querySelectorAll('.product-hero__zoom');
      if (zoomTriggers.length) {
        var zoomItems = Array.prototype.map.call(zoomTriggers, function (t) {
          return { src: t.getAttribute('data-full-src'), alt: t.getAttribute('data-full-alt') };
        });
        zoomTriggers.forEach(function (trigger, i) {
          trigger.addEventListener('click', function () {
            var lb = document.querySelector('image-lightbox');
            if (lb && typeof lb.openGallery === 'function') lb.openGallery(zoomItems, i);
          });
        });
      }

      this.thumbnails.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.goToImage(i));
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goToImage((this.currentIndex - 1 + this.slides.length) % this.slides.length);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goToImage((this.currentIndex + 1) % this.slides.length);
        });
      }

      document.addEventListener('variant:change', (e) => {
        if (e.detail && e.detail.imageId) this.goToImageById(e.detail.imageId);
      });
    }

    stopSlideMedia(slide) {
      if (!slide) return;
      var video = slide.querySelector('video');
      if (video) video.pause();
      var iframe = slide.querySelector('iframe');
      if (iframe) iframe.src = iframe.src;
    }

    goToImage(index) {
      if (index === this.currentIndex || !this.slides[index]) return;

      this.stopSlideMedia(this.slides[this.currentIndex]);

      this.slides.forEach(function(slide) { slide.hidden = true; });
      this.slides[index].hidden = false;

      this.thumbnails.forEach(function(t) { t.classList.remove('product-hero__thumbnail--active'); });
      if (this.thumbnails[index]) this.thumbnails[index].classList.add('product-hero__thumbnail--active');

      this.currentIndex = index;
    }

    goToImageById(imageId) {
      var self = this;
      this.thumbnails.forEach(function(thumb, i) {
        if (parseInt(thumb.getAttribute('data-image-id'), 10) === imageId) {
          self.goToImage(i);
        }
      });
    }
  }

  class VariantSelector extends HTMLElement {
    connectedCallback() {
      this.variantsData = this.querySelector('[data-variants-json]');
      this.variants = this.variantsData ? JSON.parse(this.variantsData.textContent) : [];
      this.optionSelects = this.querySelectorAll('[data-option-index]');
      this.priceEl = this.querySelector('[data-price]');
      this.variantIdInput = this.querySelector('[name="id"]');
      this.buyButton = this.querySelector('[data-add-to-cart]');
      this.form = this.querySelector('form');

      var self = this;
      this.optionSelects.forEach(function(sel) {
        sel.addEventListener('change', function() { self.onVariantChange(); });
      });

      if (this.form) {
        this.form.addEventListener('submit', function(e) { self.onFormSubmit(e); });
      }

      // Two-way sync with external option selectors (e.g. orbit-option-cards).
      document.addEventListener('orbit:option-change', function(e) { self.onExternalOptionChange(e); });
      document.addEventListener('orbit:request-state', function() { self.emitOrbitState(); });

      this.syncInitialState();
      this.emitOrbitState();
    }

    syncInitialState() {
      if (this.variants.length === 0) return;

      var currentId = this.variantIdInput ? parseInt(this.variantIdInput.value, 10) : null;
      var variant = null;

      if (this.variants.length === 1) {
        variant = this.variants[0];
      } else if (currentId) {
        for (var i = 0; i < this.variants.length; i++) {
          if (this.variants[i].id === currentId) {
            variant = this.variants[i];
            break;
          }
        }
      }

      if (!variant) return;

      if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      if (this.buyButton) {
        if (variant.available) {
          this.buyButton.disabled = false;
          this.buyButton.textContent = this.buyButton.getAttribute('data-add-text') || 'Add to Cart';
        } else {
          this.buyButton.disabled = true;
          this.buyButton.textContent = 'Sold Out';
        }
      }
    }

    getSelectedOptions() {
      var selected = [];
      this.optionSelects.forEach(function(sel) {
        selected[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      return selected;
    }

    findVariant(selectedOptions) {
      for (var i = 0; i < this.variants.length; i++) {
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (this.variants[i].options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return this.variants[i];
      }
      return null;
    }

    onVariantChange() {
      var selectedOptions = this.getSelectedOptions();
      var variant = this.findVariant(selectedOptions);
      if (!variant) return;

      if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());

      if (this.buyButton) {
        if (variant.available) {
          this.buyButton.disabled = false;
          this.buyButton.textContent = this.buyButton.getAttribute('data-add-text') || 'Add to Cart';
        } else {
          this.buyButton.disabled = true;
          this.buyButton.textContent = 'Sold Out';
        }
      }

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: variant, imageId: variant.image_id }
      }));

      this.emitOrbitState();
    }

    // Broadcast the current option selection so external selectors (cards) can sync.
    emitOrbitState() {
      if (this.variants.length === 0) return;
      var variant = this.findVariant(this.getSelectedOptions());
      var options = {};
      this.optionSelects.forEach(function(sel) {
        var nm = sel.getAttribute('data-option-name');
        if (nm) options[nm] = sel.value;
      });
      document.dispatchEvent(new CustomEvent('orbit:variant-change', {
        detail: {
          options: options,
          available: variant ? variant.available : false,
          variantId: variant ? variant.id : null
        }
      }));
    }

    // React to a selection made in an external option selector (the step cards).
    onExternalOptionChange(e) {
      if (!e.detail || !e.detail.name) return;
      var targetName = ('' + e.detail.name).trim().toLowerCase();
      var matched = null;
      this.optionSelects.forEach(function(sel) {
        var nm = sel.getAttribute('data-option-name');
        if (nm && nm.trim().toLowerCase() === targetName) matched = sel;
      });
      if (!matched) return;
      matched.value = e.detail.value;
      this.onVariantChange();
    }

    onFormSubmit(e) {
      e.preventDefault();
      var form = this.form;
      var buyButton = this.buyButton;
      var originalText = buyButton ? buyButton.textContent : '';
      var formData = new FormData(form);

      if (buyButton) {
        buyButton.disabled = true;
        buyButton.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function(response) {
        if (!response.ok) return response.json().then(function(err) { throw err; });
        return response.json();
      }).then(function(item) {
        document.dispatchEvent(new CustomEvent('cart:change', {
          detail: { item: item }
        }));

        if (buyButton) {
          buyButton.textContent = 'Added!';
          setTimeout(function() {
            buyButton.disabled = false;
            buyButton.textContent = originalText;
          }, 1500);
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open();
      }).catch(function(err) {
        var msg = (err && err.description) || 'Could not add to cart';
        if (buyButton) {
          buyButton.textContent = msg;
          buyButton.disabled = false;
          setTimeout(function() {
            buyButton.textContent = originalText;
          }, 3000);
        }
      });
    }
  }

  // Opens an Omnisend popup/flyout form. The Omnisend snippet arrives via the
  // Shopify app embed, so it may not have loaded when this runs; pushing onto
  // the array stub is the documented way to queue the call until it does.
  class NotifyButton extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('[data-omnisend-form]');
      if (!btn) return;

      btn.addEventListener('click', function() {
        var formId = btn.getAttribute('data-omnisend-form');
        if (!formId) return;
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', formId]);
      });
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      this.hiddenInput = document.getElementById('product-hero-form-quantity');

      if (this.input && this.hiddenInput) {
        var hiddenInput = this.hiddenInput;
        this.input.addEventListener('input', function() {
          hiddenInput.value = this.value;
        });
      }
    }
  }

  customElements.define('media-gallery', MediaGallery);
  customElements.define('variant-selector', VariantSelector);
  customElements.define('quantity-input', QuantityInput);
  customElements.define('notify-button', NotifyButton);

  } catch(e) { console.error(e); }
})();
})();
